<script lang="ts">
    export let isDisabled = false;
    export let showWhen = true;
</script>

<template>
    {#if showWhen}
        <li role="menuitem" class:disabled={isDisabled}>
            <!-- svelte-ignore a11y-invalid-attribute because javascript:void(0) accessibility -->
            {#if isDisabled}
                <a href="javascript:void(0)">
                    <span>
                        <slot></slot>
                    </span>
                </a>
            {:else}
                <a href="javascript:void(0)" on:click>
                    <span>
                        <slot></slot>
                    </span>
                </a>
            {/if}
        </li>
    {/if}
</template>